exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BottomCards-module__column___2SuK6{display:grid;gap:20px;grid-row:span 3;grid-template-rows:subgrid;grid-template-columns:subgrid}.BottomCards-module__column___2SuK6 strong{display:block}.BottomCards-module__column___2SuK6 .BottomCards-module__cards___23JFP,.BottomCards-module__column___2SuK6 .BottomCards-module__no-evidence___31laR{display:grid;gap:1rem}.BottomCards-module__column___2SuK6 .BottomCards-module__cards___23JFP{grid-template-rows:1fr 1fr;height:100%}", ""]);

// exports
exports.locals = {
	"column": "BottomCards-module__column___2SuK6",
	"cards": "BottomCards-module__cards___23JFP",
	"no-evidence": "BottomCards-module__no-evidence___31laR"
};